import { render, staticRenderFns } from "./TransactionhistoryStarter.vue?vue&type=template&id=bd926600&"
import script from "./TransactionhistoryStarter.vue?vue&type=script&lang=js&"
export * from "./TransactionhistoryStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports